import { convertLang } from './languageUtils.js';

(function () {
  const convertPtoNav = () => {
    const pTag = document.getElementById("hnav");
    if (pTag && pTag.tagName === "P") {
      const navTag = document.createElement("nav");
      navTag.id = pTag.id;
      navTag.innerHTML = pTag.innerHTML;
      pTag.replaceWith(navTag);
    }
  };

  const setupTranslateMenu = () => {
    const hnav = document.getElementById("hnav");
    if (hnav) {
      const newContent = `
        <ul id="translate_menu" data-stt-langbar>
          <li>
            <a id="translate_lang" href="#" class="toggle-menu" data-stt-ignore></a>
            <ul class="dropdown">
              <li><a class="georgia" href="#" data-code="JA" data-value="ja" data-stt-changelang="ja" data-stt-ignore>JAPANESE</a></li>
              <li><a class="georgia" href="#" data-code="EN" data-value="en" data-stt-changelang="en" data-stt-ignore>ENGLISH</a></li>
              <li id="lang_description">This website uses an automatic machine translation service.</li>
            </ul>
          </li>
        </ul>
      `;
      hnav.insertAdjacentHTML("afterbegin", newContent);

      const toggleMenu = hnav.querySelector(".toggle-menu");
      const dropdown = hnav.querySelector(".dropdown");
      if (toggleMenu && dropdown) {
        toggleMenu.addEventListener("click", (event) => {
          event.preventDefault();
          dropdown.classList.toggle("open");
        });
      }
    }
  };

  const injectStyles = () => {
    const style = document.createElement("style");
    style.textContent = `
      #translate_menu {
        float: left;
      }
      #translate_lang {
        display: inline-flex;
        align-items: center;
        column-gap: 6px;
        color: #bca474 !important;
      }
      #translate_lang::after {
        display: none;
        position: relative;
        top: -3px;
        content: '';
        width: 7px;
        height: 7px;
        border-top: #bca474 1px solid;
        border-right: #bca474 1px solid;
        -webkit-transform: rotate(135deg);
        -ms-transform: rotate(135deg);
        transform: rotate(135deg);
      }
      #translate_lang.active::after {
        display: block;
      }
      #translate_menu a {
        margin-left: 0 !important;
      }
      #translate_menu > li {
        position: relative;
      }
      #translate_menu > li > .toggle-menu {
        text-decoration: none;
        cursor: pointer;
        color: #333;
      }
      #lang_description {
        font-size: 10px;
        color: #FFF;
        line-height: 1.1;
        padding: 4px 8px;
        font-family: Helvetica;
      }
      .dropdown {
        width: 160px;
        display: none;
        position: absolute;
        top: 130%;
        left: 0;
        background: #242424;
        line-height: 1;
        z-index: 9;
        text-align: left;
      }
      .dropdown li {
        margin-left: 0;
        line-height: 1;
      }
      .dropdown a {
        text-decoration: none;
        color: #FFF;
        display: flex;
        padding: 8px;
        font-size: 14px;
      }
      a[data-stt-active] {
        color: #bca474 !important;
      }
      .dropdown a:hover {
        text-decoration: none !important;
        background-color: #323232;
        color: #bca474 !important;
      }
      .dropdown.open {
        display: block;
      }
      .stt-lang-select.br {
        display: none;
      }
    `;
    document.head.appendChild(style);
  };

  const initialize = () => {
    convertPtoNav();
    setupTranslateMenu();
    injectStyles();
  };

  initialize();
})();

window.addEventListener("load", function () {
  // 初期ロード時の言語設定
  __stt.get('lang', function (lang) {
    const upperLang = convertLang(lang);

    const langElement = document.querySelector('#translate_lang');
    if (langElement) {
      langElement.textContent = upperLang;
      // すべての処理が終わったら .active クラスを付与
      langElement.classList.add('active');
    }
  });
});

// 言語変更時のクリックイベント
document.addEventListener("click", (event) => {
  const target = event.target;

  if (target && target.matches("[data-stt-changelang]")) {
    event.preventDefault();

    const newLang = convertLang(target.getAttribute("data-stt-changelang").toUpperCase());

    const langElement = document.querySelector("#translate_lang");
    if (langElement) {
      langElement.textContent = newLang;
    }

    // ドロップダウンを閉じる
    const dropdown = document.querySelector(".dropdown");
    if (dropdown) {
      dropdown.classList.remove("open");
    }
  }
});
